import React, { Component } from 'react';
// สำหรับ navigation
import { Link } from 'react-router-dom';

// HTTP client
import axios from 'axios';

// jwt_decode
import { jwtDecode } from 'jwt-decode';

// sweetalert2
import Swal from 'sweetalert2'
import $ from 'jquery';

// Bootstrap layout components
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';

// RSuite UI components
import {
    VStack, HStack, Input, IconButton, ButtonToolbar, Button,
    AutoComplete, InputNumber, InputGroup, Table, Pagination,
    SelectPicker, Modal, Whisper, Tooltip, Loader
} from 'rsuite';

// Date picker ที่รองรับวันที่ไทย
import { ThaiDatePicker } from 'thaidatepicker-react';

export default class ActivitiesAdminPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            modal: null,
            loading: false,
            defaultYear: null,
            queryActivity: '',
            activityData: [],
            activityLimit: 10,
            activityPage: 1,
            activitySortColumn: null,
            activitySortType: null,
            name: '',
            location: '',
            start_date: '',
            end_date: '',
            studentList: [],
            studentPage: 1,
            studentLimit: 10,
            nameList: [],
            telList: []
        };

    }

    async componentDidMount() {
        const token = localStorage.getItem('token');

        // เช็คว่า token มีจริงหรือเปล่า
        if (!token) {
            return window.location.href = '/admin/login';
        }

        try {
            // Decode JWT เพื่อตรวจสอบเวลา expire
            const decoded = jwtDecode(token);
            const currentTime = Date.now() / 1000; // วินาที

            if (decoded.exp < currentTime) {
                // Token หมดอายุ
                localStorage.removeItem('token'); // ลบ token ทิ้ง
                return window.location.href = '/admin/login';
            }

            const authHeader = {
                headers: { Authorization: `Bearer ${token}` }
            };

            await this.promisedSetState({ authHeader });

            try {
                const response = await axios.get(`${process.env.REACT_APP_API}/status/1`, this.state.authHeader);
                await this.promisedSetState({ defaultYear: response.data[0]?.default_year })

                await this.onRenderContent({ mode: 'read' });
            } catch (error) {
                console.error('Failed to fetch application data:', error);
                // Optional: redirect, show error, etc.
            }

        } catch (error) {
            console.error('Invalid token:', error);
            // token ไม่ถูกต้อง หรือ decode ไม่ได้ ให้ redirect ไป login
            localStorage.removeItem('token');
            return window.location.href = '/admin/login';
        }
    }

    fetchYearData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/years`, this.state.authHeader);
            const formattedData = response.data.map(year => ({
                value: year.year_name,
                label: year.year_name
            }));
            await this.promisedSetState({ yearData: formattedData });
        } catch (err) {
            console.log({ error: 'Failed to load fetchYearData data' });
        }
    };

    // Promise-based setState
    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    getActivityPaginatedData = () => {
        if (!this.state.activityData) return [];

        const { activitySortColumn, activitySortType, activityLimit, activityPage } = this.state;

        let data = [...this.state.activityData];

        if (activitySortColumn && activitySortType) {
            data.sort((a, b) => {
                let x = a[activitySortColumn];
                let y = b[activitySortColumn];

                if (typeof x === 'string' && typeof y === 'string') {
                    return activitySortType === 'asc' ? x.localeCompare(y) : y.localeCompare(x);
                }

                return activitySortType === 'asc' ? x - y : y - x;
            });
        }

        const start = activityLimit * (activityPage - 1);
        const end = start + activityLimit;

        return data.slice(start, end);
    };

    onChangeActivityPage = async (page) => {
        await this.promisedSetState({ activityPage: page });
        await this.onRenderContent({ mode: 'read' });
    };

    onChangeActivityLimit = async (limit) => {
        await this.promisedSetState({ activityLimit: limit, activityPage: 1 });
        await this.onRenderContent({ mode: 'read' });
    };

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            try {
                const { Column, HeaderCell, Cell } = Table;

                await this.promisedSetState({ loading: true })

                await this.fetchYearData()

                const activityRes = await axios.post(
                    `${process.env.REACT_APP_API}/student-activity/search`,
                    {
                        year: this.state.defaultYear,
                        query: this.state.queryActivity,
                    },
                    this.state.authHeader
                );

                const activityApiData = activityRes.data;

                function formatThaiDateRange(start, end) {
                    const monthsThai = [
                        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                    ];

                    if (!start) return '-';

                    const dateObjStart = new Date(start);
                    if (isNaN(dateObjStart)) return '-';

                    const dayStart = dateObjStart.getDate();
                    const monthStart = monthsThai[dateObjStart.getMonth()];
                    const yearStart = dateObjStart.getFullYear() + 543;
                    const shortYearStart = yearStart.toString().slice(-2);

                    // เช็กว่าค่า end ไม่พร้อมใช้งาน
                    const isInvalidEnd =
                        !end ||
                        end === '0000-00-00' ||
                        isNaN(new Date(end).getTime());

                    if (isInvalidEnd) {
                        return `${dayStart} ${monthStart} ${shortYearStart}`;
                    }

                    const dateObjEnd = new Date(end);
                    const dayEnd = dateObjEnd.getDate();
                    const monthEnd = monthsThai[dateObjEnd.getMonth()];
                    const yearEnd = dateObjEnd.getFullYear() + 543;
                    const shortYearEnd = yearEnd.toString().slice(-2);

                    if (dayStart === dayEnd && monthStart === monthEnd && yearStart === yearEnd) {
                        return `${dayStart} ${monthStart} ${shortYearStart}`;
                    } else if (monthStart === monthEnd && yearStart === yearEnd) {
                        return `${dayStart} - ${dayEnd} ${monthStart} ${shortYearStart}`;
                    } else if (yearStart === yearEnd) {
                        return `${dayStart} ${monthStart} - ${dayEnd} ${monthEnd} ${shortYearStart}`;
                    } else {
                        return `${dayStart} ${monthStart} ${shortYearStart} - ${dayEnd} ${monthEnd} ${shortYearEnd}`;
                    }
                }

                // ดึงจำนวนผู้เข้าร่วมของแต่ละกิจกรรม
                const mappedActivityData = await Promise.all(
                    (Array.isArray(activityApiData) ? activityApiData : [activityApiData]).map(async item => {
                        try {
                            const countRes = await axios.get(
                                `${process.env.REACT_APP_API}/student-activity/participants/count/${item.id}`,
                                this.state.authHeader
                            );

                            const count = countRes.data?.count ?? 0;

                            return {
                                id: item.id,
                                name: item.name || "-",
                                location: item.location || "-",
                                date: item.start_date && item.end_date
                                    ? formatThaiDateRange(item.start_date, item.end_date)
                                    : "-",
                                participants: count
                            };
                        } catch (err) {
                            console.error(`Error loading participant count for activity ID ${item.id}:`, err);
                            return {
                                id: item.id,
                                name: item.name || "-",
                                location: item.location || "-",
                                date: item.start_date && item.end_date
                                    ? formatThaiDateRange(item.start_date, item.end_date)
                                    : "-",
                                participants: "-"
                            };
                        }
                    })
                );

                await this.promisedSetState({
                    activityData: mappedActivityData,
                });

                const paginatedData = this.getActivityPaginatedData();

                // Setting state using promisedSetState
                await this.promisedSetState({
                    content: <>
                        <Row className='mt-3'>
                            <Col>
                                <Breadcrumb size='lg' >
                                    <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                    <Breadcrumb.Item active>การเข้าร่วมกิจกรรม</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col lg={2} className='mb-2'>
                                <HStack>
                                    <label><b>ปีงบประมาณ</b></label>
                                    <SelectPicker size='lg'
                                        data={this.state.yearData}
                                        searchable={false}
                                        cleanable={false}
                                        placeholder='กรุณาเลือก'
                                        defaultValue={this.state.defaultYear}
                                        style={{ width: '120px' }}
                                        onSelect={async (v, i) => {
                                            await this.promisedSetState({ defaultYear: v })
                                            this.onRenderContent({ mode: 'read' })
                                        }}
                                    />
                                </HStack>
                            </Col>
                            <Col>
                                <HStack>
                                    <InputGroup size='lg' style={{ width: 300 }}>
                                        <InputGroup.Addon>
                                            <i className="bi bi-search"></i>
                                        </InputGroup.Addon>
                                        <Input
                                            size='sm'
                                            onChange={e => this.promisedSetState({ queryActivity: e })}
                                            onKeyDown={e => e.key === 'Enter' && this.onRenderContent({ mode: 'read' })}
                                        />
                                    </InputGroup>
                                    <Button appearance="primary">ค้นหา</Button>
                                </HStack>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12}>
                                <Row className='mb-3'>
                                    <Col>
                                        <Button
                                            size='mb'
                                            color='green'
                                            appearance="primary"
                                            startIcon={<i className="bi bi-plus-lg"></i>}
                                            onClick={() => this.activitiesModal({ mode: 'insert' })}
                                        >
                                            เพิ่มกิจกรรม
                                        </Button>
                                    </Col>
                                </Row>

                                <Row className='mb-3'>
                                    <Col>
                                        <Table
                                            autoHeight
                                            data={paginatedData}
                                            bordered
                                            cellBordered
                                            className='shadow-sm'
                                        >
                                            <Column width={225} resizable>
                                                <HeaderCell align='center'>วันที่กิจกรรม</HeaderCell>
                                                <Cell align='center' dataKey="date" />
                                            </Column>

                                            <Column width={420} resizable>
                                                <HeaderCell>ชื่อกิจกรรม</HeaderCell>
                                                <Cell dataKey="name" />
                                            </Column>

                                            <Column width={400} resizable>
                                                <HeaderCell>สถานที่</HeaderCell>
                                                <Cell dataKey="location" />
                                            </Column>

                                            <Column width={140} resizable>
                                                <HeaderCell align='center'>ผู้เข้าร่วม (คน)</HeaderCell>
                                                <Cell align='center' dataKey="participants" />
                                            </Column>

                                            <Column width={110} align="center" fixed="right">
                                                <HeaderCell>...</HeaderCell>
                                                <Cell style={{ padding: '4px' }}>
                                                    {rowData => (
                                                        <ButtonToolbar>
                                                            <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                                <IconButton size='sm'
                                                                    color="yellow"
                                                                    appearance="primary"
                                                                    icon={<i className="bi bi-pencil-square"></i>}
                                                                    onClick={async () => {
                                                                        await this.promisedSetState({ changePassword: false, password: '', confirm_password: '' })
                                                                        await this.activitiesModal({ mode: 'update', id: rowData.id })
                                                                    }}
                                                                />
                                                            </Whisper>
                                                            <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                                <IconButton size='sm'
                                                                    color="red"
                                                                    appearance="primary"
                                                                    icon={<i className="bi bi-trash-fill"></i>}
                                                                    onClick={() => this.onConfirm({ mode: 'delete', id: rowData.id })}
                                                                />
                                                            </Whisper>
                                                        </ButtonToolbar>
                                                    )}
                                                </Cell>
                                            </Column>
                                        </Table>
                                    </Col>
                                </Row>

                                <Row className='mb-3'>
                                    <Col>
                                        <Pagination
                                            prev
                                            next
                                            first
                                            last
                                            ellipsis
                                            boundaryLinks
                                            maxButtons={5}
                                            size='md'
                                            layout={['total', 'pager']}
                                            total={this.state.activityData.length}
                                            limit={this.state.activityLimit}
                                            activePage={this.state.activityPage}
                                            onChangePage={this.onChangeActivityPage}
                                            onChangeLimit={this.onChangeActivityLimit}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </>
                })

                await this.promisedSetState({ loading: false })

            } catch (error) {
                // Handle errors here
                console.error('Error fetching data or rendering content:', error);

                // Redirect to Log In
                window.location.href = '/admin/login';
            }
        }
    };

    handleAddStudent = ({ mode, id }) => {
        this.setState(
            prev => ({
                studentList: [
                    { id: Date.now(), prefix: '', full_name: '', age: '', level: '', tel: '', status: 'EDIT' },
                    ...prev.studentList
                ],
                page: 1 // reset page to 1 เพื่อให้เห็นข้อมูลใหม่ที่บนสุด
            }),
            () => this.activitiesModal({ mode, id, sel: true })
        );
    };

    activitiesModal = async ({ mode, id, sel }) => {
        let data;

        // ดึง autocomplete lists เพิ่มเติม (ชื่อและเบอร์โทร)
        try {
            const [nameRes, telRes] = await Promise.all([
                axios.get(`${process.env.REACT_APP_API}/autocomplete-names`, this.state.authHeader),
                axios.get(`${process.env.REACT_APP_API}/autocomplete-tels`, this.state.authHeader)
            ]);
            const nameList = nameRes.data.map(item => ({ id: item.id, label: item.full_name }));
            const telList = telRes.data.map(item => ({ id: item.id, label: item.tel }));

            await this.promisedSetState({ nameList, telList });
        } catch (err) {
            console.error('Error loading autocomplete lists:', err);
            await this.promisedSetState({ nameList: [], telList: [] });
        }

        if (!sel) {
            if (mode === 'update') {
                const response = await axios.get(`${process.env.REACT_APP_API}/student-activity/${id}`, this.state.authHeader);
                const item = response.data;

                const participantRes = await axios.get(`${process.env.REACT_APP_API}/student-activity/participant/${id}`, this.state.authHeader);
                const participants = participantRes.data || [];

                const mappedParticipants = participants.map((p, index) => ({
                    id: p.id || Date.now() + index,
                    prefix: p.prefix || '',
                    full_name: p.full_name || '',
                    age: p.age || '',
                    level: p.level || '',
                    tel: p.tel || '',
                    status: undefined
                }));

                await this.promisedSetState({ studentList: [...mappedParticipants] });

                data = {
                    name: item.name || '',
                    location: item.location || '',
                    start_date: item.start_date || '',
                    end_date: (item.end_date && item.end_date !== '0000-00-00') ? item.end_date : null,
                    activityData: participants
                };

            } else {
                data = { name: '', location: '', start_date: '', end_date: '', activityData: [] };
                await this.promisedSetState({ studentList: [] });
            }

            await this.promisedSetState(data);
        }

        const { sortColumn, sortType, studentPage, studentLimit, studentList } = this.state;

        const sortedData = !sortColumn || !sortType
            ? studentList
            : [...studentList].sort((a, b) => {
                let x = a[sortColumn];
                let y = b[sortColumn];
                if (typeof x === 'string') x = x.toLowerCase();
                if (typeof y === 'string') y = y.toLowerCase();
                return sortType === 'asc' ? (x > y ? 1 : -1) : (x < y ? 1 : -1);
            });

        const paginatedData = sortedData.slice(
            (studentPage - 1) * studentLimit,
            studentPage * studentLimit
        );

        const handleChange = (participants_id, key, value) => {
            this.setState(prev => ({
                studentList: prev.studentList.map(i => i.id === participants_id ? { ...i, [key]: value } : i)
            }));
        };

        const handleEdit = (participants_id, mode) => {
            this.setState(prev => ({
                studentList: prev.studentList.map(i =>
                    i.id === participants_id ? { ...i, status: i.status === 'EDIT' ? undefined : 'EDIT' } : i
                )
            }), () => this.activitiesModal({ mode, id, sel: true }));
        };

        const handleRemove = (participants_id, mode) => {
            this.setState(prev => ({
                studentList: prev.studentList.filter(i => i.id !== participants_id)
            }), () => this.activitiesModal({ mode, id, sel: true }));
        };

        const EditableCell = ({ rowData, dataKey, type = 'string' }) => {
            const editing = rowData.status === 'EDIT';
            const value = rowData[dataKey];

            let dataSource = [];
            if (dataKey === 'full_name') dataSource = this.state.nameList;
            else if (dataKey === 'tel') dataSource = this.state.telList;

            const handleSelect = async (selectedValue) => {
                try {
                    const selectedItem = dataSource.find(item => item.id === selectedValue);
                    const response = await axios.get(`${process.env.REACT_APP_API}/activity-participants/${selectedValue}`, this.state.authHeader);
                    const participantsData = response.data;

                    this.setState(prev => ({
                        studentList: prev.studentList.map(row => {
                            if (row.id === rowData.id) {
                                if (selectedItem) {
                                    return {
                                        ...row,
                                        prefix: participantsData.prefix || '',
                                        full_name: participantsData.full_name || '',
                                        age: participantsData.age || '',
                                        level: participantsData.level || '',
                                        tel: participantsData.tel || '',
                                        status: 'EDIT',
                                    };
                                } else {
                                    return { ...row, [dataKey]: selectedValue, status: 'EDIT' };
                                }
                            }
                            return row;
                        })
                    }), () => {
                        this.activitiesModal({ mode, id, sel });
                    });
                } catch (error) {
                    console.error('Error fetching participant data:', error);
                }
            };

            if (editing) {
                if (type === 'number') {
                    return (
                        <td style={{ textAlign: 'center' }}>
                            <InputNumber
                                size="lg"
                                defaultValue={value ?? 0}
                                onChange={(val) => handleChange(rowData.id, dataKey, val)}
                            />
                        </td>
                    );
                } else {
                    return (
                        <td>
                            <input
                                list={`autoCompleteList-${rowData.id}-${dataKey}`}
                                defaultValue={value}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    handleChange(rowData.id, dataKey, inputValue);

                                    // หา id ของ item ใน dataSource
                                    const selectedItem = dataSource.find(item => item.label === inputValue);
                                    if (selectedItem) {
                                        handleSelect(selectedItem.id);
                                    }
                                }}
                                className="form-control"
                                style={{
                                    fontSize: '1.425rem',      // ขนาดตัวอักษรเล็กลง
                                    padding: '0.25rem 0.5rem', // ลดความสูง
                                }}
                            />
                            <datalist id={`autoCompleteList-${rowData.id}-${dataKey}`}>
                                {dataSource.map(item => (
                                    <option key={item.id} value={item.label} />
                                ))}
                            </datalist>
                        </td>
                    );
                }
            } else {
                return (
                    <td style={{ textAlign: type === 'number' ? 'center' : 'left', verticalAlign: 'middle' }}>
                        {value}
                    </td>
                );
            }
        };

        const ActionCell = ({ rowData }) => (
            <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '0 4px' }}>
                <ButtonToolbar>
                    <IconButton
                        size="xs"
                        color={rowData.status === 'EDIT' ? 'blue' : 'yellow'}
                        appearance="primary"
                        icon={<i className={`bi ${rowData.status === 'EDIT' ? 'bi-floppy-fill' : 'bi-pencil-square'}`} />}
                        onClick={() => handleEdit(rowData.id, mode)}
                    />
                    <IconButton
                        size="xs"
                        color="red"
                        appearance="primary"
                        icon={<i className="bi bi-trash-fill" />}
                        onClick={() => handleRemove(rowData.id, mode)}
                    />
                </ButtonToolbar>
            </td>
        );

        this.setState({
            modal: (
                <Modal size="md" backdrop="static" keyboard={false} open={true} onClose={() => this.setState({ modal: null })}>
                    <Modal.Header>
                        <Modal.Title>กิจกรรมของนักเรียนหรือเยาวชนทั่วไป</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row className="mb-3">
                                <Col lg={8}>
                                    <label>
                                        ชื่อกิจกรรม <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <Input className='ApPZ0' size="sm" defaultValue={this.state.name} onChange={e => this.setState({ name: e })} />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col lg={10}>
                                    <label>
                                        สถานที่จัดกิจกรรม <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <Input className='DWWTw' size="sm" defaultValue={this.state.location} onChange={e => this.setState({ location: e })} />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col lg={5} className="mb-3">
                                    <label>วันที่จัดกิจกรรม <span style={{ color: 'red' }}>*</span></label>
                                    <div className='jnCan' style={{ display: 'flex', alignItems: 'center' }}>
                                        <ThaiDatePicker
                                            placeholder="วัน/เดือน/ปี พ.ศ."
                                            value={this.state.start_date}
                                            inputProps={{ style: { padding: '6px 8px', borderRadius: '6px 0 0 6px', border: '1px solid #E7E5E4', width: '200px' } }}
                                            onChange={async (e) => {
                                                await this.promisedSetState({ start_date: e });
                                                await this.activitiesModal({ mode, id, sel: true });
                                            }}
                                            onClean={async () => {
                                                await this.promisedSetState({ start_date: '' });
                                                await this.activitiesModal({ mode, id, sel: true });
                                            }}
                                        />
                                        <IconButton icon={<i className="bi bi-calendar3"></i>} size="md" style={{ borderRadius: '0 6px 6px 0' }} />
                                    </div>
                                </Col>
                                <Col lg={5}>
                                    <label>ถึง</label>
                                    <div className='cA9ZU' style={{ display: 'flex', alignItems: 'center' }}>
                                        <ThaiDatePicker
                                            placeholder="วัน/เดือน/ปี พ.ศ."
                                            value={this.state.end_date}
                                            inputProps={{ style: { padding: '6px 8px', borderRadius: '6px 0 0 6px', border: '1px solid #E7E5E4', width: '200px' } }}
                                            onChange={async (e) => {
                                                await this.promisedSetState({ end_date: e });
                                                await this.activitiesModal({ mode, id, sel: true });
                                            }}
                                            onClean={async () => {
                                                await this.promisedSetState({ end_date: '' });
                                                await this.activitiesModal({ mode, id, sel: true });
                                            }}
                                        />
                                        <IconButton icon={<i className="bi bi-calendar3"></i>} size="md" style={{ borderRadius: '0 6px 6px 0' }} />
                                    </div>
                                </Col>
                            </Row>

                            <Button
                                size='sm'
                                className="mb-2"
                                color="green"
                                appearance="primary"
                                startIcon={<i className="bi bi-plus-lg"></i>}
                                onClick={() => this.handleAddStudent({ mode, id })}
                            >
                                เพิ่มรายชื่อผู้เข้าร่วมกิจกรรม
                            </Button>

                            {/* Table ธรรมดา */}
                            <div style={{ overflowX: 'auto' }}>
                                <table className="table table-bordered mb-0" style={{ minWidth: 600 }}>
                                    <thead style={{ backgroundColor: 'rgb(138,10,10)', color: 'white' }}>
                                        <tr>
                                            <td style={{ width: 40, textAlign: 'center' }}>ลำดับ</td>
                                            <td style={{ width: 75 }}>คำนำหน้า</td>
                                            <td style={{ width: 200 }}>ชื่อ-นามสกุล</td>
                                            <td style={{ width: 80, textAlign: 'center' }}>อายุ</td>
                                            <td style={{ width: 80 }}>ระดับชั้น</td>
                                            <td style={{ width: 120 }}>เบอร์โทร</td>
                                            <td style={{ width: 95, textAlign: 'center' }}>...</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedData.map((r, i) => (
                                            <tr key={r.id}>
                                                <td style={{ textAlign: 'center' }}>
                                                    {(studentPage - 1) * studentLimit + i + 1}
                                                </td>
                                                <EditableCell rowData={r} dataKey="prefix" />
                                                <EditableCell rowData={r} dataKey="full_name" />
                                                <EditableCell rowData={r} dataKey="age" type="number" />
                                                <EditableCell rowData={r} dataKey="level" />
                                                <EditableCell rowData={r} dataKey="tel" />
                                                <ActionCell rowData={r} />
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <Pagination
                                prev
                                next
                                first
                                last
                                ellipsis
                                boundaryLinks
                                maxButtons={5}
                                size="xs"
                                layout={['total', '|', 'pager']}
                                total={this.state.studentList.length}
                                limit={this.state.studentLimit}
                                activePage={this.state.studentPage}
                                onChangePage={studentPage => {
                                    this.setState({ studentPage }, () => {
                                        this.activitiesModal({ mode, id, sel: true });
                                    });
                                }}
                            />
                        </Container>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            size="sm"
                            startIcon={<i className="bi bi-floppy-fill"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ mode, id })}
                        >
                            บันทึก
                        </Button>
                        <Button size="sm" appearance="subtle" onClick={() => this.setState({ modal: null })}>
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            )
        });
    };

    Validate = async (value, className, expected = '') => {
        try {
            // Trim ค่า string เพื่อกัน user ใส่ช่องว่างเปล่า
            const input = typeof value === 'string' ? value.trim() : value;

            // ตรวจสอบว่า className ถูกต้องหรือไม่
            if (!className || typeof className !== 'string') {
                console.warn(`Invalid className: "${className}"`);
                return false;
            }

            // เปรียบเทียบค่า input กับ expected
            const isValid = input !== expected;

            const $element = $('.' + className);
            if (!$element.length) {
                console.warn(`DOM element with class ".${className}" not found.`);
            }

            if (!isValid) {
                $element.addClass('required');

                await Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false;
            } else {
                $element.removeClass('required');
                return true;
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false;
        }
    };

    onConfirm = async ({ mode, id }) => {
        // --------------------- DELETE MODE ---------------------
        if (mode === 'delete') {
            Swal.fire({
                title: `คุณต้องการลบข้อมูลใช่หรือไม่?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `<div style="font-size: 1.2rem">ตกลง</div>`,
                cancelButtonText: `<div style="font-size: 1.2rem">ยกเลิก</div>`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        this.setState({ loading: true });

                        const response = await axios.delete(
                            `${process.env.REACT_APP_API}/student-activity/${id}`,
                            this.state.authHeader
                        );

                        const data = response.data;

                        if (data.message === 'successfully') {
                            Swal.fire({
                                title: "ลบข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            }).then(async () => {
                                await this.onRenderContent({ mode: 'read' });
                                this.setState({ modal: null });
                            });
                        } else {
                            Swal.fire({
                                title: "เกิดข้อผิดพลาดในการลบ",
                                text: data.message || 'ไม่สามารถลบข้อมูลได้',
                                icon: "error",
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                        }
                    } catch (error) {
                        Swal.fire({
                            title: "เกิดข้อผิดพลาด",
                            text: error?.response?.data?.message || 'ไม่สามารถลบข้อมูลได้',
                            icon: "error",
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    }
                }

                this.setState({ loading: false });
            });

            return;
        }

        // ฟังก์ชันตรวจสอบข้อมูลก่อนส่ง
        const validateActivity = async () => {
            const validationPromises = [
                this.Validate(this.state.name, 'ApPZ0', ''),
                this.Validate(this.state.location, 'DWWTw', ''),
                this.Validate(this.state.start_date, 'jnCan', ''),
            ];
            const results = await Promise.all(validationPromises);
            return results.every(result => result === true);
        };

        if (await validateActivity()) {
            try {
                this.setState({ loading: true });

                if (mode === 'insert') {
                    const response = await axios.post(
                        `${process.env.REACT_APP_API}/student-activity`,
                        {
                            year: this.state.defaultYear || '',
                            name: this.state.name || '',
                            location: this.state.location || '',
                            start_date: this.state.start_date || '',
                            end_date: this.state.end_date || '',
                            participants: this.state.studentList || [] // 👈 เพิ่มผู้เข้าร่วมกิจกรรม
                        },
                        this.state.authHeader
                    );

                    const data = response.data;

                    if (data.message === 'successfully') {
                        Swal.fire({
                            title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        }).then(async () => {
                            await this.promisedSetState({
                                name: '',
                                location: '',
                                start_date: '',
                                end_date: '',
                                studentList: [], // 👈 เคลียร์รายชื่อหลังบันทึก
                                createdBy: '',
                                updatedBy: ''
                            });
                            await this.onRenderContent({ mode: 'read' });
                            this.setState({ modal: null });
                        });
                    }

                } else if (mode === 'update') {
                    const response = await axios.patch(
                        `${process.env.REACT_APP_API}/student-activity`,
                        {
                            id: id,
                            name: this.state.name || '',
                            location: this.state.location || '',
                            start_date: this.state.start_date || '',
                            end_date: this.state.end_date || '',
                            updatedBy: this.state.updatedBy || '',
                            participants: this.state.studentList || [] // 👈 กรณีอัปเดต
                        },
                        this.state.authHeader
                    );

                    const data = response.data;

                    if (data.message === 'successfully') {
                        Swal.fire({
                            title: "อัปเดตข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        }).then(async () => {
                            await this.promisedSetState({
                                id: '',
                                name: '',
                                location: '',
                                start_date: '',
                                end_date: '',
                                studentList: [],
                                updatedBy: ''
                            });
                            await this.onRenderContent({ mode: 'read' });
                            this.setState({ modal: null });
                        });
                    }
                }
            } catch (error) {
                Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: error.message,
                    icon: "error",
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });
            } finally {
                this.setState({ loading: false });
            }
        }
    };

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}